import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import PageLoader from '../../../../../components/PageLoader';
import Popup from '../../../../../common/components/popup';
import { selectMentorsListItems } from '../../../../../redux/mentors/selector';
import EventComponent from '../components/event.component';
import { selectCommunitiesListItems } from '../../../../../redux/community/selector';
import ModalEventPlansComponent from '../components/event-modal.component';
import { selectListItems } from '../../../../../redux/library/selector';
import { selectEventsQueryItems } from '../../../../../redux/event/events/selector';
import { events } from '../../../../../redux/event/events/action';
import { programs } from '../../../../../redux/programs/action';
import { selectProgramsListItems } from '../../../../../redux/programs/selector';




const AgencyEvent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [columnDefs, setColumnDefs] = useState({});
    const [selectEventTickets, setSelectEventTickets] = useState<any>([])
    const [addItem, setAddItem] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const mentorsListis = useSelector(selectMentorsListItems)
    const queryItems = useSelector(selectEventsQueryItems)
    const [selectedEventValues, setSelectedEventValues] = useState([]);
    const communitiesItems = useSelector(selectCommunitiesListItems)
    const ProgramsItems = useSelector(selectProgramsListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const libraryData = useSelector(selectListItems)

    const [
        selectedEvents,
        setSelectedEvents
    ] = useState<any>([])

    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])


    const fetchQueryById = () => {
        dispatch(events.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events/query`, entity: 'Event', jsonData: {
                Context: {},
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedEvents({ ...selectedEvents, [field]: event })
        setSelectEventTickets({ ...selectEventTickets, [field]: event })
    }

    // media handle form change
    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }

    useEffect(
        () => {
            createColumnDefs()

            dispatch(programs.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/one-programs/list`,
                entity: 'programs', jsonData: {
                }
            }))

                .then(() => {
                    if (parmas?.id > 0) {
                        fetchQueryById()

                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                const querydata: any = queryItems?.result?.items
                setSelectedEvents(querydata)

                const oneProgramItemsData: any = queryItems?.result?.items?.EventPlans?.map((item: any) => {
                    const itemData = {
                        Id: item?.Id,
                        EventId:item?.EventId,
                     Title: item?.Title,
            AccessTypes: item?.AccessTypes,
            DeliveryMode: item?.DeliveryMode,
            Visibility: item?.Visibility,
            MaxParticipants: item?.MaxParticipants,
            IsEnabled: item?.IsEnabled,
            StartDateUtc: item?.StartDateUtc,
            EndDateUtc: item?.EndDateUtc,

                        SessionId: item?.ContentOutlines?.[0]?.SessionId,
                        ContentOutlinesTitle: item?.ContentOutlines?.[0]?.Title,
                        Type: item?.ContentOutlines?.[0]?.Type,
                        StartTime: item?.ContentOutlines?.[0]?.StartTime,
                        EndTime: item?.ContentOutlines?.[0]?.EndTime,
         
                    }
                    return itemData
                })

                setSelectedEventValues(oneProgramItemsData)

            }
        },
        [isQuery]
    )



    const back = () => {
        navigate('/agencies/event/events')
    }



    //Save the modal data function
    const handleSaveItem = async (data: any) => {
 

        // Collect new form data

        const newItem = {
            Id: data?.Id,
            TabelId: Date.now(),
            Title: data?.Title,
            AccessTypes: data?.AccessTypes,
            DeliveryMode: data?.DeliveryMode,
            Visibility: data?.Visibility,
            MaxParticipants: data?.MaxParticipants,
             IsEnabled: data?.IsEnabled,
            StartDateUtc: data?.StartDateUtc,
            EndDateUtc: data?.EndDateUtc,
                        SessionId: data?.SessionId,
                        ContentOutlinesTitle: data?.ContentOutlinesTitle,
                        Type: data?.Type,
                        StartTime: data?.StartTime,
                        EndTime: data?.EndTime,
                    
              
            

        }

        //Update the new data
        setSelectedEventValues((prevState: any) => {
            // Check if the item exists by ID
            const exists = prevState.some((item: any) => item.Id === newItem.Id || item.TabelId === newItem.TabelId);
            // If it exists, update it, otherwise add the new item
            return exists
                ? prevState.map((item: any) => item.Id === newItem.Id || item.TabelId === newItem.TabelId ? newItem : item)
                : [...prevState, newItem];
        });
        closeModal();
    }

    // Add button
    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add Event Tickets</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAddItem(),
        }
    ];

    //Table ColumnDef Function
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Title', headerName: 'Title' },
            { field: 'DeliveryMode', headerName: 'DeliveryMode', },
            { field: 'Visibility', headerName: 'Visibility', },
            { field: 'MaxParticipants', headerName: 'MaxParticipants', },


        ]);
    }

    //Add the data in the Table Function
    const handleAddItem = () => {
        setAddItem({
            id: 0
        });
    }

    //Table Edit Function
    const handleEdit = (itemData: any) => {
        setAddItem({
            id: itemData.id
        })
        setSelectEventTickets(itemData)

    }

    //Table Delete Function
    const handleDelete = (data: any) => {
        setSelectedEventValues((prevState: any) =>
            prevState.filter((item: any) => item?.Id !== data?.Id)
        );

    };

    //Modal Close Function
    const closeModal = () => {
        setAddItem(undefined)
        setSelectEventTickets('')
    }

    // Modal Function
    const NewItemPopup = ({ handleSaveItem }: any) => {
        const [localItems, setLocalItems] = useState(deepCopy(selectEventTickets));
        const handleLocalFormChange = (value: any, field: any) => {
            setLocalItems((prev: any) => ({
                ...prev,
                [field]: value,
            }));
        };
        const handleItemSubmit = () => {
            setLocalItems(localItems);
            handleSaveItem(localItems)
        };
        return (
            <>
                <Popup onClose={closeModal}>
                    <ModalEventPlansComponent
                        Close={closeModal}
                        mentors={mentorsListis?.result?.items}
                        handleItemSubmit={handleItemSubmit}
                        selectEventTickets={localItems}
                        onInnerBasicFormChange={handleLocalFormChange}
                        deliverymode={libraryData?.result?.EventDeliveryMode}
                        visibility={libraryData?.result?.EventVisibility}
                        AccessTypes={libraryData?.result?.EventAccessType}


                    />

                </Popup>
            </>
        )
    }
    // Submit the events Function
    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )
        const EventTicketsItemsData: any = selectedEventValues?.map((item: any) => {
            const itemData = {
                Id: item?.Id || 0,
                EventId: item?.EventId || 0,
                Title: item?.Title,
                AccessTypes: item?.AccessTypes,
                DeliveryMode: item?.DeliveryMode,
                Visibility: item?.Visibility,
                MaxParticipants: Number(item?.MaxParticipants),
                IsEnabled: item?.IsEnabled,
                StartDateUtc: item?.StartDateUtc,
                EndDateUtc: item?.EndDateUtc,
                ContentOutlines: [
                    {
                        SessionId: item?.SessionId,
                        Title: item?.ContentOutlinesTitle,
                        Type: item?.Type,
                        StartTime: item?.StartTime,
                        EndTime: item?.EndTime,
                    }

                ],

            }
            return itemData
        })
        const eventData = {

            
            "Id": selectedEvents?.Id || 0,
            "IsActive": selectedEvents?.IsActive || false,
            "IsEnable": selectedEvents?.IsEnable || false,
            "Name": selectedEvents?.Name,
            "Description": selectedEvents?.Description,
            "StartDateUtc": selectedEvents?.StartDateUtc,
            "EndDateUtc": selectedEvents?.EndDateUtc,
            "Remarks": selectedEvents?.Remarks,
            "EntityTypeId": selectedEvents?.EntityTypeId || 0,
            "EntityTypeName": selectedEvents?.EntityTypeName || "",
            "EntityId": selectedEvents?.EntityId,
            "EventPlans": EventTicketsItemsData,
            "MediaMappings": {
                "MediaFiles": mediaFiles,
                "Templates": []

            }
        }
        if (parmas?.id > 0) {
            await dispatch(events.resetAction({ actionType: 'update' }))
            await dispatch(events.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events`, entity: 'events', jsonData: {
                    Context: {},
                    Records: [
                        eventData
                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(events.resetAction({ actionType: 'create' }))
            await dispatch(events.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events`, entity: 'events', jsonData: {

                    Context: {},
                    Records: [
                        eventData
                    ]

                }
            })).then(() => {
                back()
            })

        }

    }

    return (
        <>

            {
                addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
            }
            {isLoading ? <PageLoader /> :


                <EventComponent
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    selectedEvents={selectedEvents}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    onFormItemChange={handleFormMediaItemChange}
                    id={parmas?.id}
                    selectedEventValues={selectedEventValues}
                    columnDefs={columnDefs}
                    handleEdit={handleEdit}
                    additionButtons={additionButtons}
                    handleDelete={handleDelete}
                    communities={communitiesItems?.result?.items}
                    Programs={ProgramsItems?.result?.items}

                />
            }

        </>
    )


}


export default AgencyEvent;